/* Page produit : galerie (balayage tactile + bande repliable), quantité,
   variantes (pastilles ou déroulant selon le nombre de valeurs), ajout
   panier AJAX, description repliable, barre d'achat collante, historique.

   La configuration Liquid est lue depuis #ProductConfig (JSON) : ce fichier
   ne contient aucun Liquid et reste donc cachable. Les chaînes traduites,
   les routes localisées et le format monétaire de la boutique y transitent,
   un .js statique ne pouvant pas appeler le filtre | t.

   Les replis français ci-dessous ne servent que si la configuration est
   absente ou incomplète (page issue d'un cache antérieur au déploiement). */
(function () {
  'use strict';

  var configEl = document.getElementById('ProductConfig');
  if (!configEl) return;

  var cfg;
  try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }

  var S = cfg.strings || {};
  function str(key, fallback) {
    return typeof S[key] === 'string' && S[key].length ? S[key] : fallback;
  }

  var CART_ADD_URL = (cfg.cartAddUrl || '/cart/add') + '.js';
  var CART_URL = (cfg.cartUrl || '/cart') + '.js';

  var variants = cfg.variants || [];
  var variantInput = document.getElementById('ProductVariantId');
  var optionGroups = Array.prototype.slice.call(document.querySelectorAll('[data-option-group]'));
  var atcBtn = document.getElementById('AddToCartButton');
  var atcLabel = atcBtn ? atcBtn.querySelector('.atc-label') : null;
  var qtyInput = document.getElementById('Quantity');
  var mainImg = document.getElementById('ProductMainImage');

  /* ---------- Formatage monétaire ----------
     On réplique le format de la boutique (shop.money_format) au lieu
     d'utiliser Intl.NumberFormat : Intl rend "19,99 €" en français là où
     Liquid rend "€19.99", si bien que le prix changeait de forme dès le
     premier changement de variante. Le format arrive déjà débarrassé de
     son <span> par le gabarit. */
  var MONEY_FORMAT = cfg.moneyFormat || '';

  function group(value, decimals, thousandsSep, decimalSep) {
    var fixed = Math.abs(value).toFixed(decimals);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    var out = (decimals > 0 && parts[1]) ? whole + decimalSep + parts[1] : whole;
    return (value < 0 ? '-' : '') + out;
  }

  function money(cents) {
    var value = (cents || 0) / 100;

    if (MONEY_FORMAT) {
      return MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, token) {
        if (token === 'amount_no_decimals') return group(value, 0, ',', '.');
        if (token === 'amount_with_comma_separator') return group(value, 2, '.', ',');
        if (token === 'amount_no_decimals_with_comma_separator') return group(value, 0, '.', ',');
        return group(value, 2, ',', '.');
      });
    }

    try {
      return new Intl.NumberFormat(cfg.locale || 'fr', {
        style: 'currency', currency: cfg.currency
      }).format(value);
    } catch (e) {
      return value.toFixed(2) + ' ' + (cfg.currency || '');
    }
  }

  /* ---------- Galerie ---------- */
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumbnail-btn'));
  var strip = document.getElementById('ProductThumbnails');
  var stage = document.querySelector('[data-gallery-stage]');
  var counter = document.querySelector('[data-gallery-counter]');
  var prevBtn = document.querySelector('[data-gallery-prev]');
  var nextBtn = document.querySelector('[data-gallery-next]');
  var toggleBtn = document.querySelector('[data-gallery-toggle]');
  var toggleLabel = document.querySelector('[data-gallery-toggle-label]');
  var galleryIndex = 0;

  function showIndex(index, scrollThumb) {
    if (!thumbs.length || !mainImg) return;
    if (index < 0) index = 0;
    if (index > thumbs.length - 1) index = thumbs.length - 1;
    galleryIndex = index;

    var btn = thumbs[index];
    if (btn.dataset.srcset) mainImg.srcset = btn.dataset.srcset;
    mainImg.src = btn.dataset.image;
    if (btn.dataset.alt) mainImg.alt = btn.dataset.alt;

    thumbs.forEach(function (b, i) {
      var active = i === index;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', String(active));
    });

    if (counter) counter.textContent = (index + 1) + ' / ' + thumbs.length;
    if (prevBtn) prevBtn.disabled = index === 0;
    if (nextBtn) nextBtn.disabled = index === thumbs.length - 1;

    if (scrollThumb && strip && strip.offsetParent !== null) {
      var left = btn.offsetLeft - (strip.clientWidth / 2) + (btn.offsetWidth / 2);
      strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
  }

  thumbs.forEach(function (btn, i) {
    btn.addEventListener('click', function () { showIndex(i, false); });
  });
  if (prevBtn) prevBtn.addEventListener('click', function () { showIndex(galleryIndex - 1, true); });
  if (nextBtn) nextBtn.addEventListener('click', function () { showIndex(galleryIndex + 1, true); });

  if (toggleBtn && strip) {
    toggleBtn.addEventListener('click', function () {
      var open = !strip.classList.contains('is-open');
      strip.classList.toggle('is-open', open);
      toggleBtn.setAttribute('aria-expanded', String(open));
      if (toggleLabel) {
        if (open) {
          toggleLabel.textContent = str('hideImages', 'Masquer les visuels');
        } else {
          var template = str('viewImages', 'Voir les %%COUNT%% visuels');
          toggleLabel.textContent = template.replace('%%COUNT%%', thumbs.length);
        }
      }
      if (open) showIndex(galleryIndex, true);
    });
  }

  /* Balayage horizontal : on ne réagit qu'aux gestes nettement horizontaux
     pour ne jamais interférer avec le défilement vertical de la page. */
  if (stage && thumbs.length > 1) {
    var startX = 0, startY = 0, tracking = false;

    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    stage.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var touch = e.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      if (Math.abs(dx) < 40) return;
      if (Math.abs(dx) < Math.abs(dy) * 1.5) return;
      showIndex(dx < 0 ? galleryIndex + 1 : galleryIndex - 1, true);
    }, { passive: true });
  }

  if (strip) {
    strip.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); showIndex(galleryIndex + 1, true); thumbs[galleryIndex].focus(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); showIndex(galleryIndex - 1, true); thumbs[galleryIndex].focus(); }
    });
  }

  if (thumbs.length) showIndex(0, false);

  /* ---------- Description repliable ----------
     Écrêtée par le CSS à 220 px au-dessus de 1024 px pour ne pas repousser
     le bouton d'achat ; le bouton n'apparaît que si le texte déborde
     vraiment. En dessous, la description est renvoyée en bas de colonne et
     montrée en entier : le bouton n'a plus lieu d'être. */
  (function () {
    var wrap = document.querySelector('[data-description]');
    if (!wrap) return;
    var body = wrap.querySelector('[data-description-body]');
    var descToggle = wrap.querySelector('[data-description-toggle]');
    var descLabel = wrap.querySelector('[data-description-toggle-label]');
    if (!body || !descToggle) return;

    var wide = window.matchMedia('(min-width: 1025px)');

    function syncDescription() {
      if (!wide.matches) {
        wrap.classList.remove('is-clamped');
        descToggle.hidden = true;
        return;
      }
      if (wrap.classList.contains('is-open')) {
        descToggle.hidden = false;
        return;
      }
      /* Marge de 4 px : évite d'afficher le bouton pour un dépassement d'un
         pixel dû aux arrondis de rendu. */
      var overflows = body.scrollHeight > body.clientHeight + 4;
      wrap.classList.toggle('is-clamped', overflows);
      descToggle.hidden = !overflows;
    }

    descToggle.addEventListener('click', function () {
      var open = !wrap.classList.contains('is-open');
      wrap.classList.toggle('is-open', open);
      descToggle.setAttribute('aria-expanded', String(open));
      if (descLabel) {
        descLabel.textContent = open
          ? str('readLess', 'Réduire')
          : str('readMore', 'Lire la suite');
      }
    });

    syncDescription();
    if (wide.addEventListener) wide.addEventListener('change', syncDescription);
    else if (wide.addListener) wide.addListener(syncDescription);
    window.addEventListener('resize', syncDescription);

    /* Les polices web changent la hauteur du texte après coup : on
       recalcule une fois qu'elles sont posées. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncDescription).catch(function () {});
    }
  })();

  /* ---------- Quantité ---------- */
  function clampQty(delta) {
    if (!qtyInput) return;
    var v = parseInt(qtyInput.value, 10);
    if (isNaN(v)) v = 1;
    v += delta;
    if (v < 1) v = 1;
    if (v > 99) v = 99;
    qtyInput.value = v;
  }
  var minus = document.querySelector('.qty-minus');
  var plus = document.querySelector('.qty-plus');
  if (minus) minus.addEventListener('click', function () { clampQty(-1); });
  if (plus) plus.addEventListener('click', function () { clampQty(1); });

  /* ---------- Sélection de variante ----------
     Une option est rendue soit en pastilles (radios), soit en déroulant
     natif au-delà de 10 valeurs. Les deux formes sont lues ici de la même
     manière, via le conteneur [data-option-group]. */
  function groupValue(g) {
    var select = g.querySelector('[data-option-select]');
    if (select) return select.value;
    var checked = g.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  function chosenValues() {
    return optionGroups.map(groupValue);
  }

  /* Une combinaison correspond si chaque option choisie égale l'optionN de
     la variante. Les positions non renseignées ne contraignent rien. */
  function matches(variant, values) {
    if (values[0] != null && variant.option1 !== values[0]) return false;
    if (values[1] != null && variant.option2 !== values[1]) return false;
    if (values[2] != null && variant.option3 !== values[2]) return false;
    return true;
  }

  function findVariant() {
    if (!optionGroups.length) return variants[0] || null;
    var chosen = chosenValues();
    for (var i = 0; i < variants.length; i++) {
      if (matches(variants[i], chosen)) return variants[i];
    }
    return null;
  }

  /* Signale les valeurs qui ne mènent à aucune variante disponible compte
     tenu des autres options choisies : pastille barrée, entrée de
     déroulant suffixée. On ne désactive rien : le client peut sélectionner
     et voir l'état plutôt que buter sur un contrôle inerte. */
  function markAvailability() {
    if (!optionGroups.length) return;
    var chosen = chosenValues();
    var unavailable = str('unavailable', 'Indisponible');

    optionGroups.forEach(function (g, gi) {
      function isAvailable(value) {
        var probe = chosen.slice();
        probe[gi] = value;
        return variants.some(function (variant) {
          return matches(variant, probe) && variant.available;
        });
      }

      var select = g.querySelector('[data-option-select]');
      if (select) {
        Array.prototype.forEach.call(select.options, function (opt) {
          /* data-label conserve le libellé d'origine : sans lui, le suffixe
             s'accumulerait à chaque recalcul. */
          var base = opt.getAttribute('data-label') || opt.value;
          opt.textContent = isAvailable(opt.value) ? base : base + ' — ' + unavailable;
        });
        return;
      }

      var inputs = Array.prototype.slice.call(g.querySelectorAll('input[type="radio"]'));
      inputs.forEach(function (input) {
        var ok = isAvailable(input.value);
        var label = g.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !ok);
        /* aria-disabled et non disabled : la pastille reste atteignable au
           clavier, l'information est portée aux lecteurs d'écran. */
        input.setAttribute('aria-disabled', String(!ok));
      });

      var selected = g.querySelector('input[type="radio"]:checked');
      var readout = g.querySelector('[data-option-selected]');
      if (readout && selected) readout.textContent = selected.value;
    });
  }

  /* Le prix barré et le badge de remise suivent la variante :
     ils restaient auparavant bloqués sur le premier variant. */
  function renderPrice(v) {
    var priceEls = document.querySelectorAll('[data-price-current], [data-price-current-sticky]');
    Array.prototype.forEach.call(priceEls, function (el) { el.textContent = money(v.price); });

    var onSale = v.compare_at_price && v.compare_at_price > v.price;

    var compareEl = document.querySelector('[data-price-compare]');
    if (compareEl) {
      compareEl.textContent = onSale ? money(v.compare_at_price) : '';
      compareEl.hidden = !onSale;
    }

    var badgeEl = document.querySelector('[data-price-badge]');
    if (badgeEl) {
      if (onSale) {
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        badgeEl.textContent = '-' + pct + '%';
        badgeEl.hidden = false;
      } else {
        badgeEl.hidden = true;
      }
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-price-current]'), function (el) {
      el.classList.toggle('price-sale', !!onSale);
    });
  }

  function setAvailability(available) {
    if (!atcBtn) return;
    atcBtn.disabled = !available;
    if (atcLabel) {
      atcLabel.textContent = available
        ? str('addToCart', 'Ajouter au panier')
        : str('outOfStock', 'Rupture de stock');
    }
  }

  function onVariantChange() {
    markAvailability();

    var v = findVariant();
    if (!v) {
      setAvailability(false);
      if (atcLabel) atcLabel.textContent = str('unavailable', 'Indisponible');
      return;
    }
    if (variantInput) variantInput.value = v.id;
    renderPrice(v);
    setAvailability(v.available);

    /* Si la variante a son propre visuel, on positionne la galerie dessus */
    if (v.featured_image && v.featured_image.src) {
      var target = -1;
      for (var i = 0; i < thumbs.length; i++) {
        var thumbSrc = thumbs[i].dataset.image || '';
        if (v.featured_image.src.split('?')[0] === thumbSrc.split('?')[0]) { target = i; break; }
      }
      if (target >= 0) showIndex(target, true);
      else if (mainImg) { mainImg.srcset = ''; mainImg.src = v.featured_image.src; }
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  optionGroups.forEach(function (g) {
    g.addEventListener('change', function (e) {
      if (!e.target) return;
      if (e.target.type === 'radio' || e.target.tagName === 'SELECT') onVariantChange();
    });
  });

  /* ---------- Ajout au panier (AJAX) ---------- */
  var form = document.getElementById('ProductForm');
  var feedback = document.getElementById('AtcFeedback');

  function setFeedback(message, isError) {
    if (!feedback) return;
    feedback.textContent = message;
    feedback.classList.toggle('is-error', !!isError);
    feedback.hidden = false;
  }

  function refreshCartBadge() {
    fetch(CART_URL, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Le sélecteur est porté par .cart-icon, pas par .cart-badge seule :
           le badge des favoris réutilise cette classe et le précède dans
           l'en-tête. Un querySelector('.cart-badge') écrirait le nombre
           d'articles du panier dans le compteur des favoris. */
        var badge = document.querySelector('.cart-icon .cart-badge');
        if (!badge) return;
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
      })
      .catch(function () {});
  }

  if (form && atcBtn) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      /* État d'attente par classe plutôt que par changement de libellé :
         une chaîne de moins à traduire, et le bouton ne change pas de
         largeur pendant la requête. aria-busy porte l'information pour
         les lecteurs d'écran. */
      atcBtn.disabled = true;
      atcBtn.classList.add('is-busy');
      atcBtn.setAttribute('aria-busy', 'true');
      if (feedback) feedback.hidden = true;

      fetch(CART_ADD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variantInput.value, 10),
          quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1
        })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          setFeedback(str('addedToCart', 'Produit ajouté au panier.'), false);
          refreshCartBadge();
        })
        .catch(function () {
          setFeedback(str('addError', "Impossible d'ajouter ce produit. Vérifiez la variante sélectionnée ou réessayez."), true);
        })
        .then(function () {
          atcBtn.disabled = false;
          atcBtn.classList.remove('is-busy');
          atcBtn.removeAttribute('aria-busy');
        });
    });
  }

  /* ---------- Barre d'achat collante (mobile) ----------
     inert plutôt que aria-hidden : un bouton focalisable dans un conteneur
     aria-hidden est une violation WCAG et un avertissement navigateur. */
  var sticky = document.getElementById('StickyAtc');
  if (sticky && atcBtn && 'IntersectionObserver' in window) {
    var setSticky = function (visible) {
      sticky.classList.toggle('visible', visible);
      if ('inert' in HTMLElement.prototype) {
        sticky.inert = !visible;
      } else {
        sticky.setAttribute('aria-hidden', String(!visible));
      }
    };
    setSticky(false);
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { setSticky(!entry.isIntersecting); });
    }, { threshold: 0 }).observe(atcBtn);

    var stickyBtn = sticky.querySelector('.sticky-atc-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { atcBtn.click(); });
    }
  }

  /* ---------- Historique "récemment consultés" ---------- */
  try {
    var entry = cfg.recentlyViewed;
    if (entry && entry.handle) {
      var rv = JSON.parse(localStorage.getItem('rv_products') || '[]');
      rv = rv.filter(function (p) { return p && p.handle !== entry.handle; });
      rv.unshift(entry);
      localStorage.setItem('rv_products', JSON.stringify(rv.slice(0, 8)));
    }
  } catch (e) {}

  /* État initial : marque les combinaisons indisponibles dès le chargement,
     sans quoi le client découvre l'épuisement seulement après avoir cliqué. */
  if (optionGroups.length > 0) onVariantChange();
})();
